import * as yup from "yup";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";

const requestSchema = yup.object({
  id: yup.number().required(),
  name: yup.string().required(),
  title: yup.string().required(),
  phrase: yup.string().required(),
});

export function useUpdateSmsSnippetMutation(options = {}) {
  const queryClient = useQueryClient();

  return useMutation(
    (dto) => {
      const req = requestSchema.validateSync(dto, {
        strict: true,
      });
      return http.post(HTTP_ENDPOINTS.smsSnippets.update(), req);
    },
    {
      ...options,
      onSuccess: () => {
        [QUERY_KEYS.smsSnippets.all, QUERY_KEYS.smsSnippets.paginated].forEach(
          (key) => {
            queryClient.invalidateQueries({
              queryKey: [key],
            });
          },
        );
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.smsSnippets.one],
        });
        options?.onSuccess?.();
      },
    },
  );
}
